// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m0y9","colBig":"styles_colBig__3RmAi","colSmall":"styles_colSmall__2W-32"};